import type { SuccessResponse } from '../../types'
import type { API } from '../types'
import { http } from '../../index'
import { PaymentHistory, User } from './models'

export const account = {
  getUser: () => http.get<User>('/account').then(User.parse),

  /** Get public user data using their invite code */
  getPublicUser: (inviteCode: string) => http.static.get(http.getURL(`/share/${inviteCode}`)).json(User.PublicSchema.parse),

  delete: () => http.post<{ success: boolean }>('/delete', {}),

  update: (data: Partial<User>) => http.post<User>('/account', data).then(User.parse),

  redeem: (code: string) => http.post<API.Subscription.RedeemResult>('/coupon', { coupon: code }),

  async subscribe(data: API.Subscription.Params, { isMeet = false } = {}): Promise<API.SuccessResponse<{ checkout_url?: string }>> {
    const result: API.Subscription.CheckoutResult = await http.post<any>(isMeet ? '/meet-subscription' : '/subscription', data)
      .catch(res => res?.json || res)

    if ('checkout_url' in result)
      return result

    return {
      success: ['active', 'trialing'].includes(result.status),
      message: ''
    }
  },

  unsubscribe: () => http.delete('/subscription').then(() => true, () => false),

  async getPayments() {
    const { payments = [] } = await http.get<{ payments: PaymentHistory[] }>('/payments')

    return payments.map(item => new PaymentHistory(item))
  },

  async getBillingPageUrl() {
    const response = await http.get<SuccessResponse<{ url: string }>>('/billing_portal')
    return response.url
  },

  changeEmail(email: string, key?: string) {
    return http.post<SuccessResponse<{ email?: string }>>('/change-email', { email, key })
  },

  /** Uploads image to cloud storage and returns an url */
  uploadImage: (img: Blob) => http.upload('image', { img }).then(e => String(e.url))
}

export const auth = {
  async login<T extends API.Auth.Provider>(provider: T, params: API.Auth.LoginParams<T>) {
    const endpoint = provider === 'microsoft' ? 'microsoft-auth' : 'auth'
    const result = await http.static.post(params, http.getURL(endpoint)).json<API.Auth.LoginResult>()

    return result
  }
}
